<template>
  <v-container fluid class="mt-5">
    <v-row class="mb-8">
      <v-col>
        <h2>Dashboard BDGD x INDGER</h2>
      </v-col>
    </v-row>

    <v-row class="mt-5" justify="start">
      <v-col class="pb-0" cols="12" sm="4" lg="2">
        <input-month
          label="Competência"
          :clearable="false"
          solo
          rules="min:7"
          :minMonth="'2023-01'"
          :selectedMonth="competencia"
          @monthSelected="setCompetencia"
        />
      </v-col>
    </v-row>

    <v-row justify="center">
      <v-col
        v-for="dataCard in dataCardsQtdEntidadesBdgd"
        :key="dataCard.value"
        cols="auto"
        md="3"
      >
        <v-card>
          <v-card-title>
            {{ dataCard.text }}
          </v-card-title>
          <v-card-title class="caption text--secondary">
            BDGD
          </v-card-title>
          <v-card-text class="py-4 display-4">
            {{
              dadosConsolidadosBdgd[dataCard.value]
                ? dadosConsolidadosBdgd[dataCard.value]
                : "-"
            }}
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>

    <v-row>
      <v-col cols="12">
        <v-card class="mt-3">
          <v-card-title>
            Comparação de dados consolidados - BDGD x INDGER
          </v-card-title>
          <v-card-text class="pa-2 mt-3">
            <v-row justify="center" class="mx-auto">
              <v-col cols="auto" md="2">
                <v-select
                  :items="itemsComparacaoConsolidadosBdgdIndger"
                  :value="selectedComparacaoConsolidadosBdgdIndger"
                  @change="setSelectedComparacaoConsolidadosBdgdIndger($event)"
                  label="Comparação"
                  solo
                />
              </v-col>
            </v-row>
            <highcharts :options="chartComparacoesSumarizadaOptions" />
          </v-card-text>

          <v-overlay
            absolute
            :opacity="0.7"
            :value="loadingDadosConsolidadosIndger"
          >
            <v-progress-circular indeterminate size="128" width="8" />
          </v-overlay>
        </v-card>
      </v-col>
    </v-row>

    <v-row>
      <v-col cols="12">
        <v-card class="mt-3">
          <v-card-title>
            QTD de Trafos por Subestação - BDGD
            <v-btn 
              color="primary" 
              icon 
              @click="downloadTrafosBySub()"
            >
              <v-icon size="30">mdi-download-circle</v-icon>
            </v-btn>
          </v-card-title>
          <v-card-text class="pa-2 mt-3">
            <highcharts :options="chartQtdTrafosBySub" />
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>

    <v-row>
      <v-col cols="12">
        <v-card class="mt-3">
          <v-card-title>
            Unidades Consumidoras - BDGD
          </v-card-title>
          <v-card-text>
            <v-row justify="space-around">
              <v-col
                v-for="dataQtdUcs in dataCardsQtdUcsBdgd"
                :key="dataQtdUcs.value"
                cols="auto"
                md="3"
              >
                <v-card outlined>
                  <v-card-title class="subtitle-1">
                    {{ dataQtdUcs.text }}
                  </v-card-title>
                  <v-card-text class="display-4">
                    {{
                      dadosQtdUcsTotais[dataQtdUcs.value]
                        ? dadosQtdUcsTotais[dataQtdUcs.value]
                        : "-" | parseNumberToFloatBrIgnoringNaN
                    }}
                  </v-card-text>
                </v-card>
              </v-col>
            </v-row>
          </v-card-text>

          <v-card-text class="pa-2 mt-3">
            <v-row justify="center" class="mx-auto">
              <v-col cols="auto" md="2">
                <v-select
                  :items="itemsQtdUcsBdgdPorChave"
                  :value="selectedQtdUcsBdgdPorChave"
                  @change="setSelectedQtdUcsBdgdPorChave($event)"
                  label="Entidade"
                  solo
                />
              </v-col>
            </v-row>
            <highcharts :options="chartQtdUcsByKey" />
            
            <v-overlay
              absolute
              :opacity="0.7"
              :value="loadingDadosQtdUcsEntidade"
            >
              <v-progress-circular indeterminate size="128" width="8" />
            </v-overlay>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>

    <v-row>
      <v-col cols="12">
        <v-card>
          <v-card-title>
            Comparação de itens faltantes - BDGD x INDGER
          </v-card-title>
          <v-card-title class="caption text--secondary">
            BDGD: {{ this.dataRegistroBdgd | formatToMonth }}<br />
            INDGER: {{ this.competencia | formatToMonth }}
          </v-card-title>
          <v-card-text class="mt-4">
            <v-row justify="space-between">
              <v-col cols="2">
                <v-select
                  :items="entidadesComparacaoItemsFaltantes"
                  :value="entidadeComparacaoItemsFaltantes"
                  @change="setEntidadeComparacaoItemsFaltantes($event)"
                  label="Entidade"
                  solo
                />
              </v-col>
              <v-col cols="6">
                <v-radio-group
                  :value="tipoComparacaoItemsFaltantes"
                  @change="setTipoComparacaoItemsFaltantes($event)"
                  row
                >
                  <v-radio label="Faltantes no INDGER" value="indger" />
                  <v-radio label="Faltantes na BDGD" value="bdgd" />
                </v-radio-group>
              </v-col>
            </v-row>
            <v-row no-gutters justify="center">
              <v-col cols="auto">
                <span
                  v-if="tipoComparacaoItemsFaltantes === 'bdgd'"
                  class="body-1"
                >
                  Há
                  <b
                    :class="
                      dadosItensFaltantes.length > 0
                        ? 'error--text'
                        : 'success--text'
                    "
                  >
                    {{ dadosItensFaltantes.length }}
                  </b>
                  {{ textEntidadeComparacaoItemsFaltantes }} ausentes na BDGD
                </span>
                <span
                  v-if="tipoComparacaoItemsFaltantes === 'indger'"
                  class="body-1"
                >
                  Há
                  <b
                    :class="
                      dadosItensFaltantes.length > 0
                        ? 'error--text'
                        : 'success--text'
                    "
                  >
                    {{ dadosItensFaltantes.length }}
                  </b>
                  {{ textEntidadeComparacaoItemsFaltantes }} ausentes no INDGER
                </span>
              </v-col>
            </v-row>
          </v-card-text>
          <v-card-text class="mt-1">
            <v-row justify="center">
              <v-col cols="auto" class="pb-0">
                <v-text-field
                  append-icon="mdi-magnify"
                  label="Pesquisar"
                  clearable
                  hide-details
                  v-model="searchItemsFaltantes"
                />
              </v-col>
            </v-row>
            <v-row justify="center">
              <v-col cols="12" md="8" lg="6">
                <v-data-table
                  :headers="[
                    {
                      text: 'Código',
                      value: 'cod',
                    },
                  ]"
                  :items="dadosItensFaltantes"
                  hide-actions
                  no-data-text="Nenhum item encontrado"
                  dense
                  class="elevation-1"
                  item-key="id"
                  :search="searchItemsFaltantes"
                />
              </v-col>
            </v-row>
          </v-card-text>

          <v-overlay
            absolute
            :opacity="0.7"
            :value="loadingDadosItensFaltantes"
          >
            <v-progress-circular indeterminate size="128" width="8" />
          </v-overlay>
        </v-card>
      </v-col>
    </v-row>
    <v-overlay :value="loadingDados" :opacity="0.8">
      <v-progress-circular indeterminate size="128" width="8" />
    </v-overlay>
  </v-container>
</template>

<script>
  import Highcharts from "highcharts";
  import HighchartsNoData from "highcharts/modules/no-data-to-display";
  HighchartsNoData(Highcharts);

  import { generateMonthlyDateRangeArray } from "@/utils/dateUtils.js";
  import dayjs from "dayjs";

  import DashboardBdgdIndgerService from "@/services/DashboardBdgdIndgerService";

  import { mapActions, mapState } from "vuex";

  export default {
    name: "DashboardBdgdIndger",
    components: {
      InputMonth: () => import("@/components/general/InputMonth.vue"),
    },
    data: () => ({
      tab: 1,
      loadingDados: true,
      loadingDadosConsolidadosIndger: false,
      loadingDadosItensFaltantes: false,
      dataRegistroBdgd: null,
      dataCardsQtdEntidadesBdgd: [
        {
          text: "QTD de Conjuntos",
          value: "qtd_conj",
        },
        {
          text: "QTD de Subestações",
          value: "qtd_sub",
        },
        {
          text: "QTD de Trafos de Força",
          value: "qtd_trafos",
        },
        {
          text: "QTD de Alimentadores",
          value: "qtd_alimentadores",
        },
      ],
      itemsComparacaoConsolidadosBdgdIndger: [
        {
          text: "QTD de Conjuntos",
          value: "qtd_conj",
        },
        {
          text: "QTD de Subestações",
          value: "qtd_sub",
        },
        {
          text: "QTD de Alimentadores",
          value: "qtd_alimentadores",
        },
      ],
      entidadesComparacaoItemsFaltantes: [
        {
          text: "Conjuntos",
          value: "conj",
        },
        {
          text: "Subestações",
          value: "sub",
        },
        {
          text: "Alimentadores",
          value: "alimentadores",
        },
      ],
      searchItemsFaltantes: "",
      dadosItensFaltantes: [],
      dadosConsolidadosBdgd: {},
      dadosConsolidadosIndger: {},
      qtdTrafosBySub: {},
      dataCardsQtdUcsBdgd: [
        {
          text: "Total de UCs",
          value: "total",
        },
        {
          text: "Total de UCs - Linhas de Distribuição",
          value: "ld",
        },
        {
          text: "Total de UCs - Subestações",
          value: "sub",
        },
        {
          text: "Total de UCs - Alimentadores",
          value: "alimentadores",
        },
      ],
      dadosQtdUcsTotais: {},
      dadosQtdUcsEntidade: {},
      loadingDadosQtdUcsEntidade: false,
      itemsQtdUcsBdgdPorChave: [
        {
          text: "Linhas de Distribuição",
          value: "ld",
        },
        {
          text: "Subestações",
          value: "sub",
        },
        {
          text: "Alimentadores",
          value: "alimentadores",
        },
      ],
    }),
    computed: {
      ...mapState("parametrosDashboardBdgdIndger", [
        "competencia",
        "selectedComparacaoConsolidadosBdgdIndger",
        "entidadeComparacaoItemsFaltantes",
        "tipoComparacaoItemsFaltantes",
        "selectedQtdUcsBdgdPorChave",
      ]),
      categories() {
        const startDate = dayjs(this.competencia, "YYYY-MM")
          .subtract(11, "month")
          .startOf("month");
        const endDate = this.competencia;

        const bdgdYear = dayjs(this.dataRegistroBdgd, "YYYY-MM").format("YYYY");

        let categoriesArray = generateMonthlyDateRangeArray(
          startDate,
          endDate,
          "YYYY-MM",
          "YYYY-MM"
        );

        categoriesArray.push(bdgdYear);

        return categoriesArray;
      },
      competenciaDe() {
        return dayjs(this.competencia, "YYYY-MM")
          .subtract(11, "month")
          .startOf("month")
          .format("YYYY-MM");
      },
      competenciaAte() {
        return this.competencia;
      },
      year() {
        return dayjs(this.competencia, "YYYY-MM").format("YYYY");
      },
      textEntidadeComparacaoItemsFaltantes() {
        return this.entidadesComparacaoItemsFaltantes.find(
          (el) => el.value === this.entidadeComparacaoItemsFaltantes
        ).text;
      },
      textEntidadeQtdUcsBdgdPorChave() {
        return this.itemsQtdUcsBdgdPorChave.find(
          (el) => el.value === this.selectedQtdUcsBdgdPorChave
        ).text;
      },
      chartComparacoesSumarizadaOptions() {
        return {
          chart: {
            type: "column",
            zooming: {
              type: "x",
            },
          },
          lang: {
            noData: "Sem dados para exibição",
          },
          credits: { enabled: false },
          title: { text: null },
          xAxis: {
            categories: this.categories,
            crosshair: true,
            labels: {
              formatter: function() {
                if (this.value.length < 7) return this.value;

                return dayjs(this.value, "YYYY-MM").format("MM/YYYY");
              },
            },
          },
          yAxis: {
            type: "linear",
            title: { text: null },
            plotLines: [
              {
                color: "#61B83D",
                width: 2,
                value: this.dadosConsolidadosBdgd[
                  this.selectedComparacaoConsolidadosBdgdIndger
                ], // valor da BDGD
              },
            ],
          },
          plotOptions: {
            series: {
              dataLabels: {
                enabled: true,
              },
            },
          },
          series: [
            {
              name: "INDGER",
              pointPlacement: 0,
              data: this.categories
                .map((category) => {
                  return category in this.dadosConsolidadosIndger
                    ? {
                        x: this.categories.indexOf(category),
                        y: Number(this.dadosConsolidadosIndger[category]),
                      }
                    : { x: this.categories.indexOf(category), y: null };
                })
                .filter((val) => val !== null && val.y !== null && val.y > 0),
            },
            {
              name: "BDGD",
              grouping: false, // desativa o agrupamento de series
              pointPlacement: 0,
              hidePlotLineTooltip: true,
              data: [
                {
                  x: 12,
                  y: this.dadosConsolidadosBdgd[
                    this.selectedComparacaoConsolidadosBdgdIndger
                  ],
                },
              ],
            },
          ],
        };
      },
      chartQtdTrafosBySub() {
        return {
          chart: {
            type: "column",
            zooming: {
              type: "x",
            },
          },
          lang: {
            noData: "Sem dados para exibição",
          },
          credits: { enabled: false },
          title: { text: null },
          xAxis: {
            categories: Object.keys(this.qtdTrafosBySub),
            crosshair: true,
          },
          yAxis: {
            type: "linear",
            title: { text: null },
          },
          plotOptions: {
            series: {
              dataLabels: {
                enabled: true,
              },
            },
          },
          legend: {
            enabled: false,
          },
          tooltip: {
            formatter: function() {
              const qtd = this.y;
              const potencia =
                this.series.chart.userOptions?.series[0]?.qtdTrafosBySub[this.x]
                  ?.potencia || "-";

              return `<b>${this.x}</b><br>QTD: ${qtd}<br>Potência: ${potencia}`;
            },
          },
          series: [
            {
              name: "QTD de Trafos",
              qtdTrafosBySub: this.qtdTrafosBySub,
              data: Object.keys(this.qtdTrafosBySub).map(
                (item) => this.qtdTrafosBySub[item].qtd
              ),
            },
          ],
        };
      },
      chartQtdUcsByKey() {
        return {
          chart: {
            type: "column",
            zooming: {
              type: "x",
            },
          },
          lang: {
            noData: "Sem dados para exibição",
          },
          credits: { enabled: false },
          title: {
            text: `QTD de UCs por ${this.textEntidadeQtdUcsBdgdPorChave}`,
          },
          xAxis: {
            categories: Object.keys(this.dadosQtdUcsEntidade),
            crosshair: true,
          },
          yAxis: {
            type: "linear",
            title: { text: null },
          },
          plotOptions: {
            series: {
              dataLabels: {
                enabled: true,
              },
            },
          },
          legend: {
            enabled: false,
          },
          series: [
            {
              name: `QTD de ${this.textEntidadeQtdUcsBdgdPorChave}`,
              data: Object.keys(this.dadosQtdUcsEntidade)
                .filter((item) => item.trim() != "")
                .map(
                  (item) => this.dadosQtdUcsEntidade[item]
                )
            },
          ],
        };
      },
    },
    beforeMount() {
      this.setCompetenciaInicial();
    },
    mounted() {
      this.getDados();
    },
    methods: {
      ...mapActions("parametrosDashboardBdgdIndger", [
        "setCompetenciaInicial",
        "setCompetencia",
        "setSelectedComparacaoConsolidadosBdgdIndger",
        "setEntidadeComparacaoItemsFaltantes",
        "setTipoComparacaoItemsFaltantes",
        "setSelectedQtdUcsBdgdPorChave",
      ]),
      getDados() {
        this.loadingDados = true;

        Promise.all([
          this.getDataRegistroBdgd(),
          this.getDadosConsolidadosBdgd(),
          this.getDadosConsolidadosIndger(),
          this.getBdgdQtdTrafosBySub(),
          this.getItensFaltantesByTipoAndEntidade(),
          this.getQtdTotalUcs(),
          this.getQtdUcsByChaveEntidade(),
        ])
          .catch((err) => {
            console.error(err);
            this.$toast.error("Erro ao recuperar dados.", "", {
              position: "topRight",
            });
          })
          .finally(() => (this.loadingDados = false));
      },
      getDadosConsolidadosBdgd() {
        this.dadosConsolidadosBdgd = {};

        return DashboardBdgdIndgerService.getDadosConsolidadosBdgd(this.year)
          .then((res) => {
            this.dadosConsolidadosBdgd = res;
          })
          .catch((err) => {
            throw err;
          });
      },
      getDataRegistroBdgd() {
        this.dataRegistroBdgd = null;

        const bdgdTable = {
          qtd_conj: "bdgd_conj",
          qtd_sub: "bdgd_sub",
          qtd_alimentadores: "bdgd_ctmt",
        };

        return DashboardBdgdIndgerService.getBdgdMaxDataRegistroByYear(
          this.year,
          bdgdTable[this.selectedComparacaoConsolidadosBdgdIndger]
        )
          .then((res) => {
            this.dataRegistroBdgd = res;
          })
          .catch((err) => {
            throw err;
          });
      },
      getDadosConsolidadosIndger() {
        this.loadingDadosConsolidadosIndger = true;
        this.dadosConsolidadosIndger = {};

        if (this.selectedComparacaoConsolidadosBdgdIndger === "qtd_sub") {
          return this.getIndgerQtdSub();
        }
        if (
          this.selectedComparacaoConsolidadosBdgdIndger === "qtd_alimentadores"
        ) {
          return this.getIndgerQtdAlimentadores();
        }
        if (this.selectedComparacaoConsolidadosBdgdIndger === "qtd_conj") {
          return this.getIndgerQtdConj();
        }

        throw new Error("Tipo de Comparação incorreta");
      },
      getIndgerQtdSub() {
        return DashboardBdgdIndgerService.getIndgerQtdSubByCompetencia(
          this.competenciaDe,
          this.competenciaAte
        )
          .then((res) => {
            this.dadosConsolidadosIndger = res;
          })
          .catch((err) => {
            this.$toast.error("Falha ao buscar QTD Sub.", "", {
              position: "topRight",
            });
            throw err;
          })
          .finally(() => (this.loadingDadosConsolidadosIndger = false));
      },
      getIndgerQtdAlimentadores() {
        return DashboardBdgdIndgerService.getIndgerQtdAlimentadoresByCompetencia(
          this.competenciaDe,
          this.competenciaAte
        )
          .then((res) => {
            this.dadosConsolidadosIndger = res;
          })
          .catch((err) => {
            this.$toast.error("Falha ao buscar QTD Alimentadores.", "", {
              position: "topRight",
            });
            throw err;
          })
          .finally(() => (this.loadingDadosConsolidadosIndger = false));
      },
      getIndgerQtdConj() {
        return DashboardBdgdIndgerService.getIndgerQtdConjByCompetencia(
          this.competenciaDe,
          this.competenciaAte
        )
          .then((res) => {
            this.dadosConsolidadosIndger = res;
          })
          .catch((err) => {
            this.$toast.error("Falha ao buscar QTD de Conjuntos.", "", {
              position: "topRight",
            });
            throw err;
          })
          .finally(() => (this.loadingDadosConsolidadosIndger = false));
      },
      getBdgdQtdTrafosBySub() {
        this.qtdTrafosBySub = {};

        return DashboardBdgdIndgerService.getBdgdQtdTrafosBySub(this.year)
          .then((res) => {
            this.qtdTrafosBySub = res;
          })
          .catch((err) => {
            throw err;
          });
      },
      getItensFaltantesByTipoAndEntidade() {
        this.dadosItensFaltantes = [];
        this.loadingDadosItensFaltantes = true;

        return DashboardBdgdIndgerService.getItensFaltantesByTipoAndEntidade(
          this.tipoComparacaoItemsFaltantes,
          this.entidadeComparacaoItemsFaltantes,
          this.competencia,
          this.year
        )
          .then((res) => {
            this.dadosItensFaltantes = res;
          })
          .catch((err) => {
            this.$toast.error("Falha - Comparação itens faltantes.", "", {
              position: "topRight",
            });
            throw err;
          })
          .finally(() => (this.loadingDadosItensFaltantes = false));
      },
      getQtdTotalUcs() {
        this.dadosQtdUcsTotais = {};

        return DashboardBdgdIndgerService.getQtdTotalUcs(this.year)
          .then((res) => {
            this.dadosQtdUcsTotais = res;
          })
          .catch((err) => {
            throw err;
          });
      },
      getQtdUcsByChaveEntidade() {
        this.dadosQtdUcsEntidade = {};
        this.loadingDadosQtdUcsEntidade = true;

        return DashboardBdgdIndgerService.getQtdUcsByChaveEntidade(
          this.year,
          this.selectedQtdUcsBdgdPorChave
        )
          .then((res) => {
            this.dadosQtdUcsEntidade = res;
          })
          .catch((err) => {
            throw err;
          })
          .finally(() => (this.loadingDadosQtdUcsEntidade = false));
      },
      downloadTrafosBySub() {
        this.$toast.info("Preparando seu arquivo para download.", "", {
          position: "topRight",
          timeout: 3000,
        });

        DashboardBdgdIndgerService.downloadXlsxBdgdQtdTrafosBySub(
          this.year,
          { timeout: 60 * 60 * 1000 }
        )
          .then(async (res) => {
            const url = window.URL.createObjectURL(new Blob([res.data]));
            const link = document.createElement("a");
            link.href = url;
            link.setAttribute("download", `QTD_Trafos_por_SUB.xlsx`);
            document.body.appendChild(link);
            link.click();
          })
          .catch((err) => {
            this.$toast.error("Erro no download do arquivo.", "", {
              position: "topRight",
              timeout: 5000,
            });
            console.error(err);
          });
      }
    },
    watch: {
      competencia() {
        this.getDados();
      },
      selectedComparacaoConsolidadosBdgdIndger() {
        this.getDadosConsolidadosIndger();
      },
      entidadeComparacaoItemsFaltantes() {
        this.getItensFaltantesByTipoAndEntidade();
      },
      tipoComparacaoItemsFaltantes() {
        this.getItensFaltantesByTipoAndEntidade();
      },
      selectedQtdUcsBdgdPorChave() {
        this.getQtdUcsByChaveEntidade();
      },
    },
  };
</script>

<style></style>
